import React from 'react';
import Script from 'next/script';
import newRelicScript from '../../../lib/util/newRelic';

/**
 * New Relic script.
 */
const NewRelicScript = () => {
  if (!process.env.NEXT_PUBLIC_NEW_RELIC_APP_ID) return null;
  return (
    <>
      <Script
        id="newRelicScript"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: newRelicScript(process.env.NEXT_PUBLIC_NEW_RELIC_APP_ID),
        }}
      />
    </>
  );
};

export default NewRelicScript;
